import { Popover as HeadlessPopover, PopoverButton, PopoverPanel } from '@headlessui/react';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Button, ButtonProps } from './Button';

export interface PopoverProps {
    /** Content of the trigger button. */
    trigger: ReactNode;
    /** Accessible name of the trigger when the visible text is not enough. */
    triggerLabel?: string;
    triggerVariant?: ButtonProps['variant'];
    /** Panel content; call `close` after an action. */
    children: (close: () => void) => ReactNode;
    className?: string;
}

/** Button that opens a raised panel under it: left-aligned below 640 px (where page actions wrap to the left), right-aligned from there up. Esc and outside click close it; focus is managed by Headless UI. */
export const Popover = ({ trigger, triggerLabel, triggerVariant = 'outline', children, className }: PopoverProps) => (
    <HeadlessPopover className="relative">
        <PopoverButton as={Button} variant={triggerVariant} aria-label={triggerLabel}>
            {trigger}
        </PopoverButton>
        <PopoverPanel className={clsx('absolute left-0 top-full z-40 sm:left-auto sm:right-0 mt-1 w-[min(22rem,calc(100vw-2rem))] rounded-card bg-raised p-2 shadow-e2 outline-none', className)}>
            {({ close }) => <>{children(close)}</>}
        </PopoverPanel>
    </HeadlessPopover>
);
